import Vue from 'vue'
import Router from 'vue-router'
import menuModule from 'vuex-store/modules/menu'

import Scenario from '../views/scenarios/Scenario'

Vue.use(Router)

export default new Router({
  mode: 'hash', // Demo is living in GitHub.io, so required!
  linkActiveClass: 'is-active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      name: 'Ошибка скачивания',
      meta: {
        labelTrans: 'errors.downloadError'
      },
      path: '/error/downloadError',
      component: require('../views/errors/DownloadError')
    },
    {
      name: 'Рассылки',
      meta: {
        labelTrans: 'campaigns.campaigns'
      },
      path: '/campaigns',
      component: require('../views/campaigns/Campaigns')
    },
    {
      name: 'Ежедневные Рассылки',
      meta: {
        labelTrans: 'campaigns.dailyCampaigns'
      },
      path: '/campaigns/daily',
      component: require('../views/campaigns/daily/DailyCampaigns.vue')
    },
    {
      name: 'Архив рассылок',
      meta: {
        labelTrans: 'campaigns.campaignsArchive'
      },
      path: '/archive',
      component: require('../views/campaigns/Archive')
    },
    {
      name: 'Новая рассылка',
      meta: {
        labelTrans: 'campaigns.newCampaign'
      },
      path: '/campaigns/new',
      component: require('../views/campaigns/Campaign')
    },
    {
      name: 'Копия рассылки',
      path: '/campaigns/copy/:idcopy',
      component: require('../views/campaigns/Campaign'),
      props: true
    },
    {
      name: 'Рассылка',
      meta: {
        labelTrans: 'campaigns.campaign'
      },
      path: '/campaigns/:id',
      component: require('../views/campaigns/Campaign'),
      props: true
    },
    {
      name: 'Сценарии',
      meta: {
        labelTrans: 'scenarios.scenarios'
      },
      path: '/scenarios',
      component: require('../views/scenarios/Scenarios')
    },
    {
      name: 'Лицевой счет',
      meta: {
        labelTrans: 'billing.billing'
      },
      path: '/billing',
      component: require('../views/billing/Balance')
    },

    {
      name: 'Аналитика затрат',
      meta: {
        labelTrans: 'billing.summaryLabel'
      },
      path: '/billing/summary',
      component: require('../views/billing/BillingSummaryDashboard')
    },
    {
      name: 'Детализации',
      meta: {
        labelTrans: 'billing.detailsLabel'
      },
      path: '/billing/details',
      component: require('../views/billing/BillingDetails')
    },

    {
      name: 'Уведомления',
      meta: {
        labelTrans: 'billing.notificationsLabel'
      },
      path: '/billing/notifications',
      component: require('../views/billing/BillingNotifications')
    },
    {
      path: '/scenarios/:campaignid/new',
      component: Scenario,
      name: 'Новый сценарий',
      meta: {
        labelTrans: 'scenarios.newScenario'
      },
      props: true
    },
    {
      name: 'Сценарий',
      meta: {
        labelTrans: 'scenarios.scenario'
      },
      path: '/scenarios/:campaignid/:id',
      component: require('../views/scenarios/Scenario'),
      props: true
    },
    {
      name: 'Пользователи',
      path: '/users',
      meta: {
        labelTrans: 'users.users'
      },
      component: require('../views/users/Users')
    },
    {
      name: 'Пользователь',
      meta: {
        labelTrans: 'users.user'
      },
      path: '/users/:id',
      component: require('../views/users/User'),
      props: true
    },
    {
      name: 'Новый пользователь',
      meta: {
        labelTrans: 'users.newUser'
      },
      path: '/users/new',
      component: require('../views/users/User')
    },
    {
      name: 'Данные пользователя',
      meta: {
        labelTrans: 'users.userData'
      },
      path: '/profiles/:id',
      component: require('../views/profiles/Profile'),
      props: true
    },
    {
      name: 'Номера на прозвон',
      path: '/callTasks/:id',
      component: require('../views/calltasks/CalltasksCampaign'),
      props: true
    },
    {
      name: 'Мониторинг рассылки',
      path: '/monitoring/:id',
      component: require('../views/campaigns/CampaignMonitoring'),
      props: true
    },
    {
      name: 'Аггрегированный отчёт',
      path: '/campaignCallsResult/:id',
      component: require('../views/campaigns/CampaignCallsResult'),
      props: true
    },
    {
      name: 'Тестовые номера',
      path: '/callTasksTest/:id',
      component: require('../views/calltasks/TestCalltasksCampaign'),
      props: true
    },
    {
      name: 'Результат теста',
      path: '/callTasksTestResult/:campaignid/:id',
      component: require('../views/calltasks/TestCallTasksResult'),
      props: true
    },

    {
      name: 'Авторизация',
      meta: {
        labelTrans: 'authentication.authentication'
      },
      path: '/login',
      component: require('../views/authentication/Login')
    },
    {
      name: 'Регистрация',
      meta: {
        labelTrans: 'authentication.Регистрация'
      },
      path: '/sign-up',
      component: require('../views/authentication/SignUp')
    },
    {
      name: 'Настройка прав',
      meta: {
        labelTrans: 'permissions.permissions'
      },
      path: '/permissions',
      component: require('../views/settings/Permissions')
    },
    {
      name: 'Настройка приложения',
      meta: {
        labelTrans: 'appConfig.appConfig'
      },
      path: '/appconfig',
      component: require('../views/settings/AppConfig')
    },
    ...generateRoutesFromMenu(menuModule.state.items),
    {
      path: '*',
      redirect: '/campaigns'
    }
  ]
})
// Menu should have 2 levels.
function generateRoutesFromMenu (menu = [], routes = []) {
  for (let i = 0, l = menu.length; i < l; i++) {
    let item = menu[i]
    if (item.path) {
      routes.push(item)
    }
    if (!item.component) {
      generateRoutesFromMenu(item.children, routes)
    }
  }
  return routes
}



// WEBPACK FOOTER //
// ./client/router/index.js